var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Log } from '../../../../log';
import { DriverAdapter } from './DriverAdapter';
import { DriverLogChannel } from './DriverLog';
import { DriverState } from './DriverState';
import { HttpRequest } from './HttpRequest';
import { StateBridge } from './StateBridge';
export class HttpDriverAdapter extends DriverAdapter {
    constructor(equipmentId, driverName, Driver, ipAddress, simulate, onConnectionLost, onControlStatus, translate, logFactory) {
        super(Driver.key, Driver.emulatorKey, ipAddress, simulate, logFactory, translate);
        this.equipmentId = equipmentId;
        this.driverName = driverName;
        this.Driver = Driver;
        this.onConnectionLost = onConnectionLost;
        this.onControlStatus = onControlStatus;
        this.isConnecting = false;
        this.isDisconnectPending = false;
        this.onHttpConnectionLost = this.onHttpConnectionLost.bind(this);
    }
    get transport() {
        if (this.httpRequest === undefined)
            throw new Error('httpRequest is undefined');
        return this.httpRequest;
    }
    computeInitialOfflineCaps(config) {
        var _a, _b;
        const emulatorKey = (_a = this.Driver.emulatorKey) !== null && _a !== void 0 ? _a : this.Driver.key;
        const httpRequest = new HttpRequest(this.ipAddress, this.logFactory, this.Driver.httpRequestOptions, this.simulate ? emulatorKey : undefined);
        this.state = new DriverState(this.logFactory, {});
        this.driver = new this.Driver(httpRequest, this.state, new DriverLogChannel(Log.channel(this.driverName), this.ipAddress), this);
        (_b = this.stateBridge) === null || _b === void 0 ? void 0 : _b.destroy();
        this.stateBridge = new StateBridge(this.state, this.equipmentId, this.driver, httpRequest, this.onControlStatus, this, this.logFactory);
        super.computeInitialOfflineCaps(config);
        httpRequest.close();
    }
    doConfigure(config, token) {
        const _super = Object.create(null, {
            doConfigure: { get: () => super.doConfigure }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (token.isCancelled)
                return;
            if (this.httpRequest === undefined) {
                this.log.error('httpRequest is undefined');
                return;
            }
            if (this.httpRequest.emulator !== undefined &&
                this.httpRequest.emulator.onConfigure !== undefined) {
                this.httpRequest.emulator.onConfigure(config);
            }
            return _super.doConfigure.call(this, config, token);
        });
    }
    doConnect(credentials, config, storage, token) {
        const _super = Object.create(null, {
            doConnect: { get: () => super.doConnect },
            doInitialize: { get: () => super.doInitialize }
        });
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield _super.doConnect.call(this, credentials, config, storage, token);
            if (result !== 'connected')
                return result;
            if (token.isCancelled)
                return 'connectFailed';
            const emulatorKey = (_a = this.Driver.emulatorKey) !== null && _a !== void 0 ? _a : this.Driver.key;
            this.isConnecting = true;
            this.httpRequest = new HttpRequest(this.ipAddress, this.logFactory, this.Driver.httpRequestOptions, this.simulate ? emulatorKey : undefined);
            this.httpRequest.onConnectionLost(this.onHttpConnectionLost);
            this.state = new DriverState(this.logFactory, storage);
            this.driver = new this.Driver(this.httpRequest, this.state, new DriverLogChannel(Log.channel(this.driverName), this.ipAddress), this);
            (_b = this.stateBridge) === null || _b === void 0 ? void 0 : _b.destroy();
            this.stateBridge = new StateBridge(this.state, this.equipmentId, this.driver, this.httpRequest, this.onControlStatus, this, this.logFactory);
            result = yield _super.doInitialize.call(this, credentials, config, storage, token);
            if (token.isCancelled)
                return 'connectFailed';
            if (this.isDisconnectPending) {
                this.isConnecting = false;
                yield this.doDisconnect(true, token);
                return 'connectFailed';
            }
            if (result !== 'connected') {
                if (!this.httpRequest.isClosed)
                    this.httpRequest.close();
                this.httpRequest = undefined;
            }
            this.isConnecting = false;
            return result;
        });
    }
    doDisconnect(expected, token) {
        const _super = Object.create(null, {
            doDisconnect: { get: () => super.doDisconnect }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (token.isCancelled)
                return;
            if (this.isConnecting) {
                this.isDisconnectPending = true;
            }
            else if (this.httpRequest !== undefined) {
                this.isDisconnectPending = false;
                yield _super.doDisconnect.call(this, true, token);
                if (this.httpRequest.emulator !== undefined &&
                    this.httpRequest.emulator.onDisconnect !== undefined) {
                    this.httpRequest.emulator.onDisconnect();
                }
                if (!this.httpRequest.isClosed)
                    this.httpRequest.close();
                this.httpRequest = undefined;
                this.phase = 'disconnected';
            }
        });
    }
    onHttpConnectionLost() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.stateBridge === undefined)
                throw new Error('stateBridge undefined');
            this.stateBridge.isConnected = false;
            yield this.disconnect(false);
            this.phase = 'disconnected';
            this.isConnecting = false;
            this.isDisconnectPending = false;
            if (this.httpRequest !== undefined && !this.httpRequest.isClosed)
                this.httpRequest.close();
            this.httpRequest = undefined;
            this.onConnectionLost();
        });
    }
}
